<template>
  <h1>Open Private Issue Report Vue</h1>
</template>
